import React from 'react'
import { InputContainer } from '../../../../../../common/components/form/form.module';

export default function ModalRateCardRuleComponent({ Close
    , messageDelayPeriod, weights, distances, selectedRateCards, shippingTypes, shipmentTypePreference, handleItemSubmit, selectLogistics, onInnerBasicFormChange }: any) {

    const timeSlots = [
        {
            Disabled: false,
            Selected: false,
            Text: '10 AM to 12 PM',
            Description: '10 AM to 12 PM',
            Value: 10
        },
        {
            Disabled: false,
            Selected: false,
            Text: '12 PM to 2 PM',
            Description: '12 PM to 2 PM',
            Value: 20
        },
        {
            Disabled: false,
            Selected: false,
            Text: '2 PM to 4 PM',
            Description: '2 PM to 4 PM',
            Value: 30
        },
        {
            Disabled: false,
            Selected: false,
            Text: '4 PM to 6 PM',
            Description: '4 PM to 6 PM',
            Value: 40
        }
    ]
    return (

        <div className="  w-full p-2 bg-white shadow-md rounded-md">
            <h1 className="text-xl font-bold mb-4 text-center">Add RateCard Rule</h1>
            <div className=" grid md:grid-cols-3 lg:grid-cols-4 gap-4 border p-4">
                <InputContainer
                    label="Name"
                    name="Name"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'Name',

                        )
                    }}
                    type="text"
                    value={selectLogistics?.Name}
                />
                <InputContainer

                    label="Shipping Type Preference"
                    labelField="Text"
                    list={shipmentTypePreference}
                    onValueChange={(event: any, newValue: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'ShippingTypePreferenceId'

                        );
                    }}
                    type="select"
                    value={selectLogistics?.ShippingTypePreferenceId}
                    valueField="Value"
                />
                <InputContainer

                    label="ShippingType"
                    labelField="ShippingTypeName"
                    list={shippingTypes}
                    onValueChange={(event: any, newValue: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'ShippingTypeId'

                        );
                    }}
                    type="select"
                    value={selectLogistics?.ShippingTypeId}
                    valueField="Id"
                />
                <InputContainer

                    label="Include Vehicle Amount"
                    name="IsIncludeVehicleAmount"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event,
                            'IsIncludeVehicleAmount'
                        )
                    }}
                    type="checkbox"
                    value={selectLogistics?.IsIncludeVehicleAmount}
                />
                <InputContainer

                    label="RTOCharge"
                    name="RTOCharge"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'RTOCharge',

                        )
                    }}
                    type="number"
                    value={selectLogistics?.RTOCharge}
                />
                {selectedRateCards?.LogisticsOrderType == 'Cargo' ?
                    <InputContainer

                        label="Fuel Charge"
                        name="FuelCharge"
                        onValueChange={(event: any) => {
                            onInnerBasicFormChange(event.target.value,
                                'FuelCharge',

                            )
                        }}
                        type="number"
                        value={selectLogistics?.FuelCharge}
                    /> : null}
                {selectedRateCards?.LogisticsOrderType == 'Cargo' ?
                    <InputContainer

                        label="Waiting Charge"
                        name="Waiting Charge"
                        onValueChange={(event: any) => {
                            onInnerBasicFormChange(
                                event.target.value,
                                'WaitingCharge',

                            )
                        }}
                        type="number"
                        value={selectLogistics?.WaitingCharge}
                    /> : null}
                {selectedRateCards?.LogisticsOrderType == 'Cargo' ?
                    <InputContainer

                        label="Peak Season Charge"
                        name="PeakSeasonCharge"
                        onValueChange={(event: any) => {
                            onInnerBasicFormChange(
                                event.target.value,
                                'PeakSeasonCharge',

                            )
                        }}
                        type="number"
                        value={selectLogistics?.PeakSeasonCharge}
                    /> : null}

                <InputContainer

                    label="DeliveryCharge"
                    name="DeliveryCharge"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'DeliveryCharge',

                        )
                    }}
                    type="number"
                    value={selectLogistics?.DeliveryCharge}
                />
                {selectedRateCards?.LogisticsOrderType == 'Cargo' ?
                    <InputContainer

                        label="Toll Charge"
                        name="TollCharge"
                        onValueChange={(event: any) => {
                            onInnerBasicFormChange(
                                event.target.value,
                                'TollCharge',

                            )
                        }}
                        type="number"
                        value={selectLogistics?.TollCharge}
                    />
                    : null}
                {selectedRateCards?.LogisticsOrderType == 'Cargo' ?

                    <><div></div>  <div></div></> : <><div></div>  <div></div></>}

                <InputContainer

                    label="DistanceUnit"
                    labelField="SystemKeyword"
                    list={distances}
                    onValueChange={(event: any, newValue: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'DistanceUnitId',

                        );
                    }}
                    type="select"
                    value={selectLogistics?.DistanceUnitId}
                    valueField="Id"
                />

                <InputContainer

                    label="MinimunDistance"
                    name="MinimunDistance"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'MinimunDistance',

                        )
                    }}
                    type="number"
                    value={selectLogistics?.MinimunDistance}
                />
                <InputContainer

                    label="MaximumDistance"
                    name="MaximumDistance"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'MaximumDistance',

                        )
                    }}
                    type="number"
                    value={selectLogistics?.MaximumDistance}
                />
                <InputContainer

                    label="DistanceIncrement"
                    name="DistanceIncrement"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'DistanceIncrement',

                        )
                    }}
                    type="number"
                    value={selectLogistics?.DistanceIncrement}
                />
                <InputContainer

                    label="DistanceIncrementCharge"
                    name="DistanceIncrementCharge"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'DistanceIncrementCharge',

                        )
                    }}
                    type="number"
                    value={selectLogistics?.DistanceIncrementCharge}
                />
                <div></div>
                <div></div>
                <div></div>
                <InputContainer

                    label="WeightUnit"
                    labelField="SystemKeyword"
                    list={weights}
                    onValueChange={(event: any, newValue: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'WeightUnitId',

                        );
                    }}
                    type="select"
                    value={selectLogistics?.WeightUnitId}
                    valueField="Id"
                />

                <InputContainer

                    label="MinimumWeight"
                    name="MinimumWeight"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'MinimumWeight',

                        )
                    }}
                    type="number"
                    value={selectLogistics?.MinimumWeight}
                />

                <InputContainer

                    label="MaximumWeight"
                    name="MaximumWeight"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'MaximumWeight',

                        )
                    }}
                    type="number"
                    value={selectLogistics?.MaximumWeight}
                />

                <InputContainer

                    label="WeightIncrement"
                    name="WeightIncrement"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'WeightIncrement',

                        )
                    }}
                    type="number"
                    value={selectLogistics?.WeightIncrement}
                />

                <InputContainer

                    label="WeightIncrementCharge"
                    name="WeightIncrementCharge"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'WeightIncrementCharge',

                        )
                    }}
                    type="number"
                    value={selectLogistics?.WeightIncrementCharge}
                />
                <div></div>
                <div></div>
                <div></div>
                <InputContainer

                    label="PackageSizeUnit"
                    labelField="SystemKeyword"
                    list={distances}
                    onValueChange={(event: any, newValue: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'PackageSizeUnit',

                        );
                    }}
                    type="select"
                    value={selectLogistics?.PackageSizeUnit}
                    valueField="Id"
                />

                <InputContainer

                    label="MinimumLength"
                    name="MinimumLength"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'MinimumLength',

                        )
                    }}
                    type="number"
                    value={selectLogistics?.MinimumLength}
                />
                <InputContainer

                    label="MaximumLength"
                    name="MaximumLength"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'MaximumLength',

                        )
                    }}
                    type="number"
                    value={selectLogistics?.MaximumLength}
                />

                <InputContainer

                    label="MinimumBreadth"
                    name="MinimumBreadth"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'MinimumBreadth',

                        )
                    }}
                    type="number"
                    value={selectLogistics?.MinimumBreadth}
                />

                <InputContainer

                    label="MaximumBreadth"
                    name="MaximumBreadth"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'MaximumBreadth',

                        )
                    }}
                    type="number"
                    value={selectLogistics?.MaximumBreadth}
                />

                <InputContainer
                    label="MinimumHeight"
                    name="MinimumHeight"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'MinimumHeight',

                        )
                    }}
                    type="number"
                    value={selectLogistics?.MinimumHeight}
                />

                <InputContainer

                    label="MaximumHeight"
                    name="MaximumHeight"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'MaximumHeight',

                        )
                    }}
                    type="number"
                    value={selectLogistics?.MaximumHeight}
                />
                <div></div>
                <InputContainer
                    label="DurationUnit"
                    labelField="Text"
                    list={messageDelayPeriod}
                    onValueChange={(event: any, newValue: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'DurationUnitId',

                        );
                    }}
                    type="select"
                    value={selectLogistics?.DurationUnitId}
                    valueField="Value"
                />

                <InputContainer

                    label="Duration"
                    name="Duration"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'Duration',

                        )
                    }}
                    type="number"
                    value={selectLogistics?.Duration}
                />
                <InputContainer
                    label="Pickup TimeSlots"
                    labelField="Text"
                    list={timeSlots}
                    onValueChange={(newValue: any) => {
                        const timeSlotsData: any = newValue.map((option: any) => option?.value || '')
                        onInnerBasicFormChange(
                            timeSlotsData,
                            'PickupTimeSlots',

                        )
                    }}
                    type="multiselect"
                    valueField="Text"
                    value={selectLogistics?.PickupTimeSlots}
                />
                <InputContainer
                    label="Delivery TimeSlots"
                    labelField="Text"
                    list={timeSlots}
                    onValueChange={(newValue: any) => {
                        const timeSlotsData: any = newValue.map((option: any) => option?.value || '')
                        onInnerBasicFormChange(
                            timeSlotsData,
                            'DeliveryTimeSlots',

                        )
                    }}
                    type="multiselect"
                    valueField="Text"
                    value={selectLogistics?.DeliveryTimeSlots}
                />

            </div>

            <div className="flex justify-end mt-6">
                <button
                    onClick={Close}
                    type="button"
                    className="m-2 bg-blue-900 text-white rounded font-medium px-4 py-3"
                >
                    Close
                </button>
                <button
                    className="m-2 bg-blue-900 text-white rounded font-medium px-4 py-3"
                    onClick={handleItemSubmit}
                    type="submit"
                >
                    Save
                </button>
            </div>

        </div>



    )
}